import { FilterSection } from './FilterSection';
import { Filters } from '../../types/filters';
import { Slider } from '../shared/Slider';

interface ExitsFilterProps {
    filters: Filters;
    onFiltersChange: (filters: Filters) => void;
    maxExits: number;
}

export function ExitsFilter({ filters, onFiltersChange, maxExits }: ExitsFilterProps) {
    return (
        <FilterSection title="Minimum Number of Exits" defaultOpen={true}>
            <Slider
                min={0}
                max={maxExits}
                value={filters.numExitsRange[0]}
                onChange={(value) => onFiltersChange({
                    ...filters,
                    numExitsRange: [value, maxExits]
                })}
            />
        </FilterSection>
    );
} 